import React, { useEffect, useState } from "react";

import SectionTitle from "../SectionTitle";
import SalesChart from "./components/SalesChart";
import RangeFilter from "../../../../../common/components/RangeFilter";
import DashboardButton from "../DashboardButton";

const RecentSales = () => {
    const [range, setRange] = useState("this-month");
    const [customRange, setCustomRange] = useState({
        from: "",
        to: "",
    });
    const [salesData, setSalesData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filterLabel, setFilterLabel] = useState("This Month");

    const colors = ["#5433DA", "#7a59ff", "#7AAA49", "#88CD44"];

    const handleRange = (value) => {
        setRange(value);
        setCustomRange({ from: "", to: "" });
    };

    const handleCustomRange = (key, value) => {
        setRange(null);
        setCustomRange({ ...customRange, [key]: value });
    };

     const fetchSales = (url) => {
        setIsLoading(true); 
        fetch(url, {
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && data.data?.sales) {
                    const salesWithColors = data.data.sales.map((serie, index) => ({
                        ...serie,
                        color: colors[index % colors.length],
                    }));

                    setSalesData(salesWithColors);
                } else {
                    setSalesData([]);
                }
                setIsLoading(false);
            })
            .catch(() => {
                setSalesData([]);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        let url = `${EASYCOMMERCE.rest_base}/dashboard/sales`;

        if (range && !customRange.from && !customRange.to) {
            url += `?range=${range}`;
            fetchSales(url);
        } else if (!range && customRange.from && customRange.to) {
            const queryString = new URLSearchParams({
                from: customRange.from,
                to: customRange.to,
            }).toString();

            url += `?${queryString}`;
            fetchSales(url);
        }
    }, [range, customRange]);

    return (
        <div className="col-span-12 min-[1685px]:col-span-6 bg-white rounded-xl flex flex-col">
            <div className="w-full h-full flex flex-col justify-between gap-[30px]">
                <div className="flex items-center justify-between pr-6 border-b border-ec-table-stock rtl:pl-6 rtl:pr-0">
                    <SectionTitle title="Recent Sales" />

                    {!isLoading && (
                        <RangeFilter
                            range={range}
                            customRange={customRange}
                            filterLabel={filterLabel}
                            handleRange={handleRange}
                            handleCustomRange={handleCustomRange}
                            handleFilterLabel={(str) => setFilterLabel(str)}
                        />
                    )}
                </div>

                <SalesChart data={salesData} isLoading={isLoading} />
            </div>
            <div className="px-[30px] pb-[30px]">
                <DashboardButton url={`admin.php?page=easycommerce#/reports`} />
            </div>
        </div>
    );
};

export default RecentSales;
